<template>
  <div class="transactions-empty">
    <v-icon size="56" color="#c4cdd9">
      {{ icon }}
    </v-icon>
    <div class="transactions-empty__title">
      {{ title }}
    </div>
    <div v-if="subtitle" class="transactions-empty__subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TransactionsEmpty',
    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: null,
      },
      icon: {
        type: String,
        default: 'mdi-file-search-outline',
      },
    },
  }
</script>

<style lang="less" scoped>
.transactions-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #fff;
  border: 1px solid #c4cdd9;
  border-radius: 8px;
  padding: 48px 24px;

  .media-xs({
    padding: 32px 16px;
  });

  &__title {
    margin-top: 16px;
    font-size: 18px;
    font-weight: 500;
    color: #323030;
  }

  &__subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #949191;
  }
}
</style>
